import { Component } from '@angular/core';

@Component({
  selector: 'app-exam-pre-post-hero',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './exam-pre-post-hero.component.css'
})
export class ExamPrePostHeroComponent {
  name="Exámenes Pre y Post Ocupacionales";
  description = "Exámen Pre Ocupacional: Se lleva a cabo antes de la contratación para determinar si el candidato está apto, física y mentalmente, para el trabajo";
  description2 = "Exámen Post Ocupacional: Se realiza cuando el empleado deja la empresa, para evaluar su estado de salud y determinar si ha sufrido algún daño relacionado con su labor";
  routeLogo = "assets/img/enterprise/menu/ocupacionalesPrePost.svg";
  routeImage = "assets/img/enterprise/hero/fotoExamenesPreYPost.svg"

}
